import api from "../../api";
import axios from "axios";

let connectionErrorTime = 0;

function elapsedTimeSeconds() {
  return (Date.now() - connectionErrorTime) / 1000;
}

function canMakeRequest(hasRecentFailure) {
  return !hasRecentFailure || elapsedTimeSeconds() > 30;
}
function getTranslationKey(message) {
  if (!message || message.length <= 0) return "";
  const words = String(message).split(" ");
  const capitalized = words.map((w, i) =>
    i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)
  );
  return capitalized.join("").replace(/\s/g, "");
}

// === Request Interceptor ===
function InterceptRequest(context) {
  api.interceptors.request.use(
    (request) => {
      const cancelToken = axios.CancelToken.source();
      request.cancelToken = cancelToken.token;

      if (!canMakeRequest(context.failedConnectionWithAxios)) {
        cancelToken.cancel("Connection error");
        return;
      }

      attachAuthToken(request);

      if (shouldShowLoading(request)) {
        context.loading = true;
        setTimeout(() => {
          if (context.loading) {
            //console.log(request);
            if (typeof context.openResultModal === "function") {
              context.openResultModal({
                status: "warning",
                message: "timeout",
                autoCloseMs: 10000,
                source: "interceptor",
              });
              context.loading = false;
            }
          }
        }, 10000);
      }

      return request;
    },
    (error) => Promise.reject(error)
  );
}

// === Request Helpers ===
function attachAuthToken(request) {
  const token = localStorage.getItem("jwt_token");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
}

function shouldShowLoading(request) {
  const methods = ["post", "put", "delete"];
  const ignoredUrls = [
    "/api/Data/",
    "/api/Message",
    "/api/Displays",
    "/api/ColorConfigs",
    "/api/DashboardsDisplays",
    "/api/GroupsDisplays",
    "/api/AlarmHistory/comment/",
    "/api/report/generate",
    "/api/Users/updateStep",
  ];
  const url = request?.url || "";
  const method = (request?.method || "").toLowerCase();
  const isIgnored = ignoredUrls.some((u) => url.includes(u));
  return methods.includes(method) && !isIgnored;
}

// === Response Interceptor ===
function InterceptResponse(context, cookie, logout) {
  api.interceptors.response.use(
    (response) => handleResponseSuccess(response, context, cookie),
    (error) => handleResponseError(error, context, logout)
  );
}

// === Response Helpers ===
function handleResponseSuccess(response, context, cookie) {
  context.loading = false;
  context.failedConnectionWithAxios = false;

  // ✅ Extract and save new token if present
  //console.log(response);
  if (response.headers["authorization"]) {
    //console.log('new toeken found in response headers');
    const newToken = response.headers["authorization"].replace("Bearer ", "");
    localStorage.setItem("jwt_token", newToken);
    const cookieExpireTime = cookie.getExpireTime() / 60;
    cookie.setCookie("jwt_token", newToken, cookieExpireTime);
    //console.log("Set token");
  }

  if (!shouldShowLoading(response.config)) return response;

  const message = response.data.message;
  if (message && message.length > 0) {
    const key = getTranslationKey(message);
    if (typeof context.openResultModal === "function") {
      context.openResultModal({
        status: "success",
        message: key || message,
        autoCloseMs: 10000,
        source: "interceptor",
      });
    }
  }
  return response;
}

function handleResponseError(error, context, logout) {
  context.loading = false;
  if (error.response && error.response.status === 401) {
    if (typeof context.openResultModal === "function") {
      context.openResultModal({
        status: "warning",
        message: "sessionExpired",
        autoCloseMs: 10000,
        source: "interceptor",
      });
    }
    context.token = null;
    logout();
  }

  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (error.code === "ERR_NETWORK") {
    return handleConnectionRejected(error, context);
  }

  const msg = error.response?.data?.message || error.response?.data || "Unknown error";

  const key = getTranslationKey(msg);

  if (typeof context.openResultModal === "function") {
    context.openResultModal({
      status: "danger",
      message: key || msg,
      source: "interceptor",
    });
  }

  return Promise.reject(error);
}

function handleConnectionRejected(error, context) {
  if (!context.failedConnectionWithAxios || elapsedTimeSeconds() > 30) {
    connectionErrorTime = Date.now();
  }
  context.failedConnectionWithAxios = true;

  if (typeof context.openResultModal === "function") {
    context.openResultModal({
      status: "danger",
      message: "networkError",
      source: "interceptor",
    });
  }

  return Promise.reject(error);
}

export default { InterceptRequest, InterceptResponse };
